import type { Action } from "../../actions/types";

export type StoreState = { share: boolean; shares: boolean };

export const initialState = {
  share: false,
  shares: false,
};

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  switch (action.type) {
    case "GET_SHARES_SUCCESS":
    case "GET_SHARES_FAILURE":
      return { ...state, shares: false };

    case "GET_SHARES_REQUEST":
      return { ...state, shares: true };

    default:
      return state;
  }
}
